import {
  GetEntityPermissionRequiredRightsProps,
  PermissionRequiredRight,
} from '../types';

import { PERMISSIONS_REQUIRED_RIGHTS_BY_ENTITY } from './permissions-rights-by-entity';

export const getEntityPermissionRequiredRights = ({
  entity,
  context,
  permission,
}: GetEntityPermissionRequiredRightsProps) => {
  const requiredRights = (PERMISSIONS_REQUIRED_RIGHTS_BY_ENTITY[entity]?.[
    permission
  ] ??
    PERMISSIONS_REQUIRED_RIGHTS_BY_ENTITY[entity]?.[context]?.[permission] ??
    []) as PermissionRequiredRight[];

  if (requiredRights.length === 0) {
    const missingConfigsWarnMessage = context
      ? `Permission required rights aren't defined for entity ${entity}, context ${context}, and permission ${permission}`
      : `Permission required rights aren't defined for entity ${entity} and permission ${permission}`;

    console.warn(missingConfigsWarnMessage);
  }

  return requiredRights;
};
